import React from 'react';
import { List } from 'immutable';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import LandingPageHeroWithImage from './LandingPageHeroWithImage';
import LandingPageHeroWithVideo from './LandingPageHeroWithVideo';

const NodeLandingPage = ({ entity, className }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'processed'], '');
  const heroImage = entity.getIn(['field_hero', 0, 'styles', 'image_paragraph_big']);
  const heroType = entity.getIn(['field_hero', 0, 'bundle']);
  const heroVideo = entity.getIn(['field_hero', 0, 'source']);
  const heroVideoPreview = entity.getIn(['field_hero_preview_image', 0, 'styles', 'original']);
  const paragraphs = entity.get('field_paragraphs');
  const showAnchorLinks = entity.getIn(['field_show_anchor_links', 0, 'value'], false);

  const heroTypeImage = 'image';

  return (
    <article className="LandingPage">
      {heroType === heroTypeImage ? (
        <LandingPageHeroWithImage title={title} hero={heroImage} body={body} showAnchorLinks={showAnchorLinks} paragraphs={paragraphs} />
      ) : (
        <LandingPageHeroWithVideo title={title} videoUrl={heroVideo} body={body} preview={heroVideoPreview} />
      )}

      {/* Start of paragraphs */}
      {paragraphs ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <div key={`paragraph:${id}:${language}`} id={id} className="ParagraphAnchorWrapper">
                <Paragraph
                  key={`paragraph:${id}`}
                  id={id}
                  entity={paragraph.get('entity')}
                />
              </div>
            );
          })}
        </div>
      ) : null}
      {/* End of paragraphs */}

    </article>
  );
};

export default NodeLandingPage;
